/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line


  var video = document.querySelector('#myVideo');
  var playButton = document.querySelector(".play-button");
  
  // Event listener for the play/pause button
  playButton.addEventListener("click", function() {
    if (video.paused == true) {
      video.play();
      video.style.opacity = 1;
      playButton.style.visibility = 'hidden';
    } else {
      video.pause();
      playButton.style.visibility = 'visible';
    }
  });
  video.addEventListener("click", function() {
    if (video.paused == true) {
      video.play();
      playButton.style.visibility = 'hidden';
    } else {
      video.pause();
      playButton.style.visibility = 'visible';
    }
  });
  
  if(window.innerWidth < 768) {
   	video.muted = "true";
   	video.loop = "true";
//    	video.autoplay = "true";
    video.playsinline = "true";
    video.play();
  }
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


